import axios from "axios";

// const BASE_URL_CLAIMS = "https://testclaimsapi.azersigorta.az/claimsapi/api/";
// const BASE_URL_SALES = "https://progress-api-sales.azersigorta.az/api/";
// const BASE_URL_ASAN = "https://progress-api-asan.azersigorta.az/api/";

const BASE_URL_CLAIMS = "https://sales-api.progress-ims.com/api/";
const BASE_URL_SALES = "https://sales-api.progress-ims.com/api/";
const BASE_URL_ASAN = "https://asan-api.progress-ims.com/api/";

// const salesapi = (regnumber) => 
//   axios.get(`${BASE_URL_CLAIMS}Policies?registrationNumber=${regnumber}`);

const salesapi = (regnumber) => 
  axios.get(`${BASE_URL_CLAIMS}PolicySearch/GetPoliciesByRegistrationNumber/${regnumber}`);

const newsalesapi = (regnumber) => 
  axios.get(`${BASE_URL_SALES}PolicySearch/GetPoliciesByRegistrationNumber/${regnumber}`);

const asanapi = (type, number, uid) => 
  axios.get(`${BASE_URL_ASAN}${type}/${number}/CLAIMS/${uid}`);

const brandapi = () => 
  axios.get(`${BASE_URL_SALES}Classifiers/GetBrands/`);

const modelapi = (brandId) => 
  axios.get(`${BASE_URL_SALES}Classifiers/GetModels/${brandId}`);

const usersbyrole = (type) => 
  axios.get(`${BASE_URL_SALES}Users/GetUsersByRole/${type}`);

const policySectionsApi = (type, policyId) =>
  axios.get(`${BASE_URL_SALES}PolicySearch/GetPolicyCoverages/${type}/${policyId}`);


export {
  salesapi,
  asanapi,
  brandapi,
  modelapi,
  usersbyrole,
  newsalesapi,
  policySectionsApi
}
